module.exports = {
	"nl": {
		"help-tool": {
			"button-text": "Help",
			"support-button": "Krijg support",
			"support-page": {
				"create-ticket": {
					"title": "Krijg support",
					"instructions": "Dien onderstaand een aanvraag in en we zullen binnen 1 werkdag contact met u opnemen.",
					"related-content": {
						"title": "Deze kunnen misschien helpen uw probleem op te lossen"
					},
					"fields": {
						"mid": {
							"label": "Kies webwinkel",
							"validation": "Winkel is vereist"
						},
						"phoneNumber": {
							"label": "Telefoonnummer (optioneel)"
						},
						"topic": {
							"question": "Waar gaat je vraag over?",
							"label": "Selecteer een onderwerp",
							"validation": "Onderwerp is vereist",
							"options": {
								"orders": "Bestellingen",
								"settlements": "Afrekeningen",
								"agreements": "Overeenkomsten",
								"others": "Overig"
							}
						},
						"subject": {
							"label": "Onderwerp",
							"validation": "Onderwerp is vereist"
						},
						"description": {
							"label": "Bericht",
							"validation": "Omschrijving is vereist"
						},
						"attachment": {
							"label": "Bijlagen toevoegen",
							"button": "Upload",
							"info": "Door screenshots toe te voegen help je ons het probleem sneller op te lossen.",
							"supportedFileTypes": "Ondersteunde bestandstypen: .png, .jpg, .pdf",
							"error": "De totale bestandsgrootte mag niet meer zijn dan {maxSize} MB"
						}
					},
					"submit": "Verzoek indienen",
					"service-unavailable-error": "Oeps! Er is iets misgegaan, probeer het over een paar minuten nog eens. Als dit aanhoudt, vraag {link} om hulp.",
					"generic-error": "We konden je verzoek niet verwerken. Onze systemen krijgen op dit moment geen contact met elkaar. Probeer de pagina opnieuw te laden, of kom later terug. Als dit aanhoudt, neem dan voor hulp contact op met {link}.",
					"contact-link": "neem contact met ons op"
				},
				"view-ticket": {
					"title": "Klaar!",
					"details": "We hebben uw aanvraag ontvangen en u ontvangt binnen 1 werkdag een antwoord. Dit zijn uw gegevens:",
					"ticket": "Verzoek #{ticketId}",
					"email": "E-mailadres: {email}",
					"status": "Je kunt de status bekijken op onze Support-pagina.",
					"track": "Status bekijken"
				}
			},
			"header": {
				"homeLink": "Reset"
			},
			"home": {
				"greeting": "Hallo {givenName}! Hoe kunnen we je helpen?",
				"topics": "Waar heb je hulp bij nodig?"
			},
			"topics": {
				"expandButton": "Meer"
			},
			"feedback": {
				"title": "Heeft dit geholpen?",
				"optionYes": "Ja, dit heeft geholpen",
				"optionNo": "Nee, ik heb meer hulp nodig",
				"positiveFeedback": "Bedankt voor de positieve feedback, dit helpt ons om je in de toekomst meer relevante artikelen te kunnen bieden."
			},
			"freeTextFeedback": {
				"title": "Help ons te verbeteren",
				"placeholder": "Waarom vond je deze informatie niet nuttig?",
				"submitButton": "Versturen",
				"feedbackMessage": "Bedankt voor je feedback, dit helpt ons om je in de toekomst meer relevante artikelen te kunnen bieden."
			},
			"relatedContent": {
				"title": "Gerelateerde informatie"
			},
			"search": {
				"buttonLabel": "Zoeken",
				"input": "Zoek naar artikelen...",
				"loading": "Laden...",
				"results": {
					"contact": "Kun je de hulp niet vinden die je nodig hebt?",
					"empty": "Sorry, er zijn geen resultaten gevonden voor je vraag. Probeer via een andere term te zoeken.",
					"singleTopicFound": "We vonden 1 onderwerp",
					"multipleTopicsFound": "We vonden {count} onderwerpen",
					"singleArticleFound": "We vonden 1 artikel",
					"multipleArticlesFound": "We vonden {count} artikelen"
				}
			},
			"contact": {
				"title": "Neem contact met ons op",
				"channelsIntro": "Neem contact met ons op zodat we je kunnen helpen.",
				"businessDetailsTitle": "Je bedrijfsgegevens",
				"businessDetailsName": "Bedrijfsnaam",
				"businessDetailsEmail": "E-mailadres",
				"businessDetailsMid": "Webwinkel-ID",
				"phone": {
					"title": "Bel ons",
					"paragraph": "Je kunt ons op werkdagen tijdens kantooruren bellen. Als je in Zweden of het Verenigd Koninkrijk bent gevestigd, kun je ons ook in het weekend tussen 10.00 en 16.00 uur bellen."
				},
				"email": {
					"title": "E-mail ons",
					"paragraph": "Stuur ons een e-mail en we nemen zo snel mogelijk contact met je op."
				}
			},
			"errorBoundary": {
				"title": "Er is iets misgegaan",
				"message": "Het spijt ons, maar er is een fout opgetreden. Je kunt op de knop 'Ga terug' hieronder klikken om terug te gaan naar het hulpprogramma of op de knop 'Hulp inschakelen' om contact met ons op te nemen.",
				"resetButton": "Ga terug",
				"errorId": "Fout-ID: {errorId}"
			},
			"tour": {
				"prev": "Vorige",
				"next": "Volgende",
				"done": "Klaar"
			},
			"notAvailableMobile": {
				"title": "Niet beschikbaar",
				"buttonBack": "Terug",
				"paragraph": "Deze inhoud is niet beschikbaar op je apparaat. Probeer het te openen op een apparaat met een groter scherm, zoals een desktopcomputer."
			},
			"shareButton": {
				"title": {
					"article": "Deel een deeplink naar dit artikel",
					"topic": "Deel een deeplink naar dit onderwerp",
					"tour": "Deel een deeplink naar deze rondleiding"
				},
				"radioItemHome": "Home App",
				"descriptionHome": "Opent hulpartikel op de homepage van de Merchant Portal ",
				"radioItemCurrent": "Huidige pagina",
				"descriptionCurrent": "Opent hulpartikel op de huidige pagina"
			},
			"marketSelector": {
				"whichMarketToContact": "Met welke markt wilt u contact opnemen?"
			}
		},
		"orientation": {
			"title": "Ontdek meer over ..."
		},
		"helpbot": {
			"questions": {
				"whatDoYouNeedHelpWithPart1": "Hallo {name}! 👋 Ik ben uw Klarna-assistent.",
				"whatDoYouNeedHelpWithPart2": "In de meeste gevallen kan ik u binnen 5 minuten helpen met het beantwoorden van uw vraag.",
				"whatDoYouNeedHelpWithPart3": "Waar kan ik u vandaag mee van dienst zijn?",
				"selectSupportChannel": "Selecteer een kanaal voor contact met onze ondersteuningsservice.",
				"selectPayoutIssue": "Perfect! Kies een probleem gerelateerd aan uitbetalingen 👇",
				"selectOrderIssue": "Perfect! Kies een probleem gerelateerd aan bestellingen 👇",
				"capturedOrders": "Heeft u bestellingen van {link1}?",
				"capturedOrdersLink1": "geactiveerd",
				"notPaidOrder": {
					"isScheduleFollowed": "Wordt uw {link1} (inclusief vertraging van de uitbetaling) gevolgd?",
					"isScheduleFollowedLink1": "uitbetalingsschema",
					"isHoldbackOrDebt": "Als de vertragingslimiet voor de uitbetaling is verlopen, controleer dan uw {link1}. Is er een inhouding of te betalen schuld voor retouren/terugboekingen?",
					"isHoldbackOrDebtLink1": "laatste afrekeningsnota"
				},
				"paidWrongAmount": {
					"isScheduleFollowed": "Bevestig de activeringsdatum van de bestelling waarvan u de uitbetaling had verwacht en houd rekening met uw uitbetalingsvertraging. U vindt uw bestellingen {link1}. Zijn de bestellingen met een verwachte uitbetaling geactiveerd?",
					"isScheduleFollowedLink1": "hier"
				},
				"changePaymentFrequency": "Heeft u meer dan 30 geactiveerde bestellingen per maand over een periode van 3 maanden ontvangen?",
				"whenWillGetPaid": "De uitbetalingsdatum hangt af van het uitbetalingsschema en de uitbetalingstermijn die in uw contract (Algemene Voorwaarden) zijn vermeld. Als u niet zeker weet hoe uw uitbetaling is ingesteld, kunt u dit controleren in {link1}. Is het uitbetalingsschema (+uitbetalingsvertraging) gevolgd?",
				"whenWillGetPaidLink1": "Afrekeningen",
				"thatHelped": "Bedankt voor de positieve feedback, dit helpt ons bij het bieden van meer relevante hulp in de toekomst. 😀",
				"orders": {
					"haveUncapturedOrdersPart1": "Aha, ik begrijp het. Heeft u nog bestellingen die niet zijn geactiveerd?",
					"haveUncapturedOrdersPart2": "Als u niet weet hoe u dit moet controleren, gaat u naar {link1}.",
					"haveUncapturedOrdersPart2Link1": "deze pagina",
					"expirationDateSurpassed": "Is de vervaldatum voorbij? (meestal 28 dagen)",
					"customerCreditPaymentMethod": "Heeft de klant gekozen voor een betaalmethode op basis van krediet (factuur, rekening, directe afschrijving)?",
					"isOrderCaptured": "Is de bestelling {link1}?",
					"isOrderCapturedLink1": "geactiveerd"
				}
			},
			"options": {
				"payout": "Uitbetaling",
				"orders": "Bestellingen",
				"otherIssue": "Andere problemen",
				"whenPaidOrderNext": "Wanneer word ik de volgende keer betaald?",
				"notPaidOrder": "Ik ben niet betaald",
				"paidWrongAmount": "Ik heb het verkeerde bedrag betaald gekregen",
				"changeHowOftenPaid": "Ik wil wijzigen hoe vaak ik word betaald",
				"dontKnowHowToCaptureOrder": "Ik weet niet hoe ik een bestelling moet activeren",
				"missedCaptureDeadline": "Ik heb de deadline voor activeren gemist",
				"needToRefundAnOrder": "Ik moet een bestelling terugbetalen",
				"yes": "Ja",
				"no": "Nee",
				"partially": "Gedeeltelijk",
				"iNeedMoreHelp": "Ik heb meer hulp nodig",
				"thatHelped": "Dat heeft geholpen",
				"contactSupportChannel": "Neem contact op met ondersteuningskanalen"
			},
			"explanations": {
				"noCapturedOrders": "Als eerste moet u {link1}. Zodra u de bestelling heeft geactiveerd, storten wij het bedrag op uw bankrekening. Retouren en andere kosten zullen op dit bedrag in mindering worden gebracht.",
				"noCapturedOrdersLink1": "activeer een bestelling",
				"feesReturnsHoldbacks": "Retouren en andere kosten kunnen op de uitbetaling in mindering worden gebracht. Controleer of u een inhouding of te betalen schuld heeft voor retouren/terugboekingen in de {link1}.",
				"feesReturnsHoldbacksLink1": "laatste afrekeningsnota",
				"notPaidOrder": {
					"scheduleFollowed": "Zodra u een bestelling hebt geactiveerd, storten wij het bedrag op uw bankrekening volgens uw uitbetalingsschema. Retouren en andere kosten zullen op dit bedrag in mindering worden gebracht. Controleer de waarde van uw uitbetaling in uw {link1}.",
					"scheduleFollowedLink1": "laatste afrekeningsnota",
					"noHoldback": "Controleer of u de juiste bankgegevens heeft geregistreerd voor de valuta van de uitbetaling {link1}.",
					"noHoldbackLink1": "hier",
					"withHoldback": "Als de waarde van de geactiveerde bestellingen hoger is dan de schuld, controleer of u de juiste bankgegevens heeft geregistreerd voor de valuta van de uitbetaling {link1}.",
					"withHoldbackLink1": "hier"
				},
				"whenPaidOrderNext": {
					"scheduleFollowed": "U ontvangt de volgende uitbetaling volgens het uitbetalingsschema en uitbetalingsvertraging."
				},
				"changePaymentFrequency": {
					"isAble": "Ga verder door contact op te nemen met onze ondersteuning via de onderstaande kanalen.",
					"isUnable": "U voldoet helaas niet aan de vereisten voor het wijzigen van uw uitbetalingsschema."
				},
				"orders": {
					"uncapturedDynamicYes": "Ik zie dat u {number} bestellingen heeft die nog niet zijn geactiveerd.",
					"uncapturedDynamicNo": "Ik zie dat u geen bestellingen heeft die nog niet zijn geactiveerd",
					"uncapturedYesPart1": "Tijd om bestellingen te activeren! Als u dit wilt doen,",
					"uncapturedYesPart2": "1. Ga naar de pagina ‘Bestellingen’ {link1}.",
					"uncapturesYesPart2Link1": "door hier te klikken",
					"uncapturedYesPart3": "2. Klik op de Klarna-referentie op de bestelling die u wilt activeren",
					"uncapturedYesPart4": "3. Kies de artikelen of voeg een bedrag toe dat u wilt activeren",
					"uncapturedYesPart5": "4. Klik op ‘activeren’",
					"uncapturedNoPart1": "Als u een bestelling wilt activeren, moet u eerst bestellingen hebben die u kunt activeren.",
					"uncapturedNoPart2": "Als u een bestelling activeert, betekent dit dat u bevestigt dat de bestelling naar de klant is verzonden. Dit moet altijd worden gedaan op dezelfde dag waarop de bestelling wordt verzonden, voor elke bestelling. Als u een bestelling activeert, informeert u ons ook dat we een uitbetaling aan u moeten starten voor die bestelling. Lees meer over het activeren van een bestelling {link1}.",
					"uncapturedNoLink1": "hier",
					"customerCreditPaymentMethodNo": "We kunnen helaas een bestelling niet verlengen als deze is verlopen. U zult de bestelling opnieuw moeten aanmaken.",
					"expirationDateSurpassedYes": "Neem contact op met onze ondersteuning via een van de onderstaande kanalen, zodat wij u kunnen helpen bij het verlengen van de bestelling.",
					"expirationDateSurpassedNo": "Ga naar {link1}. Selecteer de bestelling door het vakje naast het Klarna-referentienummer aan te vinken. Klik op ‘Verleng vervaldatum’ en bevestig uw verzoek.",
					"expirationDateSurpassedNoLink1": "Bestellingen > Te activeren",
					"isOrderCapturedYesPart1": "Selecteer de artikelen die u wilt terugbetalen en klik op ‘Terugbetaling’. U kunt ook eerst op ‘Terugbetaling’ klikken, en het bedrag invoeren dat u wilt terugbetalen - u kiest welke manier voor u het beste werkt.",
					"isOrderCapturedYesPart2": "Uw klant ontvangt een terugbetaling van het bedrag dat zij al hebben voldaan binnen 2-5 werkdagen. En dit bedrag zal worden afgetrokken van uw volgende uitbetaling.",
					"isOrderCapturedNo": "Heeft u een niet-geactiveerde bestelling die u niet gaat verzenden, kunt u de hele bestelling {link1}. Ga naar de {link2} en klik op ‘Bestelling annuleren’.",
					"isOrderCapturedNoLink1": "annuleren",
					"isOrderCapturedNoLink2": "bestellingspagina",
					"refundPartiallyCaptured": "Als u de bestelling gedeeltelijk geactiveerd hebt voor artikelen die u verzonden heeft en u de rest niet gaat sturen, moet u het niet-geactiveerde deel van de bestelling vrijgeven. Ga naar de {link1}, klik op ‘Meer acties’ en selecteer ‘Vrijgeven’.",
					"refundPartiallyCapturedLink1": "bestellingspagina"
				}
			},
			"messages": {
				"sorryToHearThat": "Het spijt me dat ik u niet heb kunnen helpen. U zult zo spoedig mogelijk worden doorgestuurd voor contact met onze ondersteuning."
			},
			"button": {
				"label": "Ondersteuning krijgen"
			},
			"contact": {
				"chat": "Chatten met een medewerker",
				"ticket": "Een ticket indienen",
				"times": {
					"minutes": "Wachttijd: {time} minuut/minuten",
					"hours": "Wachttijd: {time} uur",
					"days": "Wachttijd: {time} dag(en)"
				}
			}
		}
	}
};